import React from 'react';
import * as Icons from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Reveal } from '../hooks/useReveal';
import { SectionTitle } from './About';

const Services = () => {
  const { t } = useLanguage();
  return (
    <section id="services" className="section-pad bg-[#14120d]">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <SectionTitle eyebrow={t.services.eyebrow} title={t.services.title} subtitle={t.services.subtitle} />
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
          {t.services.items.map((item, i) => {
            const Icon = Icons[item.icon] || Icons.Music;
            return (
              <Reveal key={item.title} delay={i * 80}>
                <div className="card-lux p-8 h-full group">
                  <div className="w-14 h-14 rounded-sm border border-[#e6b83f]/40 flex items-center justify-center mb-6 group-hover:bg-[#e6b83f]/10 transition-colors">
                    <Icon size={24} strokeWidth={1.4} className="text-[#f5deA0]" />
                  </div>
                  <h3 className="font-deco text-xl font-semibold text-[#f7f1e3] mb-3">{item.title}</h3>
                  <p className="font-sans-el text-[15px] leading-relaxed text-[#c2bbaa] font-light">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
